import React, { useState, useEffect } from "react";
import Button from "../../Button/Button";
import Modal from "../../Modal/Modal";
import "../AddSectionModal/AddSectionModal.css";

const EditSectionModal = ({ onClose, onSave, initialName = "", initialIsFatal = false }) => {
  const [name, setName] = useState(initialName);
  const [isFatal, setIsFatal] = useState(initialIsFatal);
  const [error, setError] = useState("");

  useEffect(() => {
    setName(initialName);
    setIsFatal(initialIsFatal);
  }, [initialName, initialIsFatal]);

  const handleSave = () => {
    if (!name.trim()) {
      setError("Section name cannot be empty");
      return;
    }
    onSave(name.trim(), isFatal);
    onClose();
  };

  const footer = (
    <>
      <Button variant="outline" onClick={onClose}>
        Cancel
      </Button>
      <Button variant="primary" onClick={handleSave}>
        Save
      </Button>
    </>
  );

  return (
    <Modal
      isOpen={true}
      onClose={onClose}
      title="Edit Section"
      maxWidth="460px"
      footer={footer}
    >
      <div className="section-modal-form-group">
        <label className="section-modal-label">Section Name</label>
        <input
          type="text"
          className="form-control"
          value={name}
          onChange={(e) => {
            setName(e.target.value);
            if (error) setError("");
          }}
          placeholder="Enter section name"
        />
        {error && <p className="section-modal-error">{error}</p>}
      </div>

      <div className="section-modal-form-group">
        <label className="section-modal-label">Is Fatal</label>
        <div className="section-modal-radio-group">
          <label className="section-modal-radio-label">
            <input
              type="radio"
              name="is_fatal"
              className="section-modal-radio-input"
              checked={isFatal === true}
              onChange={() => setIsFatal(true)}
            />
            <span>True</span>
          </label>
          <label className="section-modal-radio-label">
            <input
              type="radio"
              name="is_fatal"
              className="section-modal-radio-input"
              checked={isFatal === false}
              onChange={() => setIsFatal(false)}
            />
            <span>False</span>
          </label>
        </div>
      </div>
    </Modal>
  );
};

export default EditSectionModal;

